import type { IconNode } from '../types';

/**
 * @name soup
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuMjQ4IDNjLjI3My4xLjgwOC41My43NDcgMS4zNi0uMDUuODMtLjkzOCAxLjItLjk4OSAyLjAyLS4wNi43OC4zMzMgMS4yNC43MjcgMS42MiIgLz4KICA8cGF0aCBkPSJNMTYuMjUyIDNjLjI2OC4xLjc5NC41My43NDUgMS4zNi0uMDYuODMtLjkyMyAxLjItLjk5MyAyLjAyLS4wNS43OC4zMzggMS4yNC43MjUgMS42MiIgLz4KICA8cGF0aCBkPSJNMTkuNSAxMiAyMiA2IiAvPgogIDxwYXRoIGQ9Ik00IDEyYTEgMSAwIDAwLS45OSAxLjEzM0E5IDkgMCAwMDEyIDIxYTkgOSAwIDAwOC45OS03Ljg2N0ExIDEgMCAwMDIwIDEyeiIgLz4KICA8cGF0aCBkPSJNNi4yNTIgM2MuMjY4LjEuNzk0LjUzLjc0NSAxLjM2LS4wNi44My0uOTIzIDEuMi0uOTkzIDIuMDItLjA1Ljc4LjMzOCAxLjI0LjczNSAxLjYyIiAvPgogIDxwYXRoIGQ9Ik03IDIxaDEwIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/soup
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Soup: IconNode = [
  [
    'path',
    { d: 'M11.248 3c.273.1.808.53.747 1.36-.05.83-.938 1.2-.989 2.02-.06.78.333 1.24.727 1.62' },
  ],
  [
    'path',
    { d: 'M16.252 3c.268.1.794.53.745 1.36-.06.83-.923 1.2-.993 2.02-.05.78.338 1.24.725 1.62' },
  ],
  ['path', { d: 'M19.5 12 22 6' }],
  ['path', { d: 'M4 12a1 1 0 00-.99 1.133A9 9 0 0012 21a9 9 0 008.99-7.867A1 1 0 0020 12z' }],
  [
    'path',
    { d: 'M6.252 3c.268.1.794.53.745 1.36-.06.83-.923 1.2-.993 2.02-.05.78.338 1.24.735 1.62' },
  ],
  ['path', { d: 'M7 21h10' }],
];

export default Soup;
